const Connect = require("react-redux").connect;
const PurchasedBodyModelView = require("../components/PurchasedBodyModelView");
const CheckoutActions = require("actions/checkout");
const CroquisActions = require("actions/croquis");
const DialogActions = require("actions/dialog");

const internals = {};

internals.connect = Connect(
    (state, { match: { params } }) => ({
        token: state.auth.credentials.token,
        croquis: state.croquis.purchased[params.id] && {
            ...state.croquis.purchased[params.id],
            downloadPackage:
                state.checkout.downloadPackages.dict[
                    state.croquis.purchased[params.id].downloadPackage
                ]
        }
    }),
    {
        // TODO id is extraneous b/c our API doesn't expose
        // a fetch single purchase by id route
        fetchData: id => {
            return dispatch => {
                return dispatch(CroquisActions.fetchPurchasedData());
            };
        },
        onDownloadOptionsClick: croquisId => {
            return dispatch => {
                return dispatch(DialogActions.openDownloadDialog(croquisId));
            };
        },
        onUpgradeClick: modelId => {
            return (dispatch, getState) => {
                // Upgrades are redeeming a premium download package by definition
                const { downloadPackages } = getState().checkout;
                dispatch(
                    CheckoutActions.selectDownloadPackage(
                        downloadPackages.byName.premium
                    )
                );

                dispatch(CheckoutActions.startTransaction("upgrade", modelId));
                dispatch(DialogActions.openTransactionDialog());
            };
        }
    }
);

module.exports = internals.connect(PurchasedBodyModelView);



// WEBPACK FOOTER //
// ./src/routes/purchased-body-model-view/containers/PurchasedBodyModelView.js